<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <CommunityCard>
      <template #image>
        <div class="image-container">
          <sc-image v-if="isEditMode" class="sc-image" :media="fields.image" />
          <ShImage v-else :src="imageSrc" :alt="imageAlt" />
        </div>
      </template>
      <template #imageCta>
        <sh-button
          v-if="!isEditMode && ctaHref"
          :[btnLinkKey]="ctaHref"
          :color="ctaColor"
          :target="ctaTarget"
        >
          {{ ctaText }}
        </sh-button>
      </template>
      <template #title>
        <sc-text v-if="isEditMode || title" :field="fields.title" />
      </template>
      <template #firstTag>
        <sc-text v-if="isEditMode || firstTag" :field="fields.tag1" />
      </template>
      <template #secondTag>
        <sc-text v-if="isEditMode || secondTag" :field="fields.tag2" />
      </template>
      <template #cta>
        <sh-button
          v-if="!isEditMode && ctaHref"
          size="small"
          :[btnLinkKey]="ctaHref"
          :color="ctaColor"
          :target="ctaTarget"
        >
          {{ ctaText }}
        </sh-button>
      </template>
      <sc-link v-if="isEditMode" class="sc-link" :field="fields.cta" />
    </CommunityCard>
  </sc-render>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Image, Link, Text } from '@sitecore-jss/sitecore-jss-vue'
import { CommunityCard, ShImage } from '@sohohouse/design-system'

import get from '~/helpers/get'
import mapFields from '~/helpers/map-fields'
import { getButtonType } from '~/helpers/get-button-type'

import ScRender from '../sc-render'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'CommunityTile',

  components: {
    ScImage: Image,
    ScLink: Link,
    ScText: Text,
    ScRender,
    ShImage,
    CommunityCard
  },

  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapFields({
      imageSrc: 'image.value.src',
      imageAlt: 'image.value.alt',
      title: 'title.value',
      firstTag: 'tag1.value',
      secondTag: 'tag2.value',
      ctaHref: 'cta.value.href',
      ctaText: 'cta.value.text',
      ctaTarget: 'cta.value.target'
    }),
    ctaColor () {
      return get(this.fields, 'ctaColor.value', 'primary')
    },
    btnLinkKey () {
      return getButtonType(this.ctaHref)
    }
  }
}
</script>

<style lang="scss" scoped>
.image-container {
  ::v-deep .sc-image-wrapper img {
    width: 100%;
    height: auto;
  }
}
</style>
